exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-buttons>.btn[data-v-3c8427d8]{white-space:nowrap}.action-buttons>.btn[data-v-3c8427d8]:not(:first-child){margin-left:.25rem}.action-buttons>.btn[data-v-3c8427d8]:not(:last-child){margin-right:.25rem}", ""]);

// exports
